import axios from "axios";
import { useAuthStore } from "@/stores/authStore";

export const backendApi = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:5001",
  headers: { "Content-Type": "application/json" },
});
export const uploadApi = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:5001",
  headers: {},
});

backendApi.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});
uploadApi.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});

backendApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore();
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      if (authStore.refreshToken) {
        originalRequest._retry = true;
        try {
          await authStore.refresh();
          originalRequest.headers.Authorization = `Bearer ${authStore.token}`;
          return backendApi(originalRequest);
        } catch (err) {
          authStore.logout();
        }
      } else {
        if(!originalRequest.url === "/grade/") authStore.logout();
      }
    }

    return Promise.reject(error);
  }
);
uploadApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore();
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      if (authStore.refreshToken) {
        originalRequest._retry = true;
        try {
          await authStore.refresh();
          originalRequest.headers.Authorization = `Bearer ${authStore.token}`;
          return uploadApi(originalRequest);
        } catch (err) {
          authStore.logout();
        }
      } else {
        authStore.logout();
      }
    }

    return Promise.reject(error);
  }
);